import { render, staticRenderFns } from "./SwitchActiveInterface.vue?vue&type=template&id=01336cc6&scoped=true&"
import script from "./SwitchActiveInterface.vue?vue&type=script&lang=ts&"
export * from "./SwitchActiveInterface.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchActiveInterface.vue?vue&type=style&index=0&id=01336cc6&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01336cc6",
  null
  
)

export default component.exports